import { IconStore } from '../../../IconStore';
import CardInfoTooltip from '../../ui-elements/CardInfoTooltip';

const RETURN_VS_MARKET_INFO = 'Compares portfolio percentage return versus the United States market over the same chart period.';

function formatReturnPct(value) {
  if (typeof value !== 'number') {
    return '—';
  }
  const prefix = value >= 0 ? '+' : '';
  return `${prefix}${value.toFixed(2)}%`;
}

function ReturnVsMarketCard(props) {
  const textStyle = {
    marginBottom: 0
  };
  const subTextStyle = {
    fontSize: 14,
    verticalAlign: 'top'
  };
  const displayPortfolio = formatReturnPct(props.portfolioReturnPct);
  
  return (
    <div className="card border-light shadow-sm card-metric">
      <CardInfoTooltip text={RETURN_VS_MARKET_INFO} />
      <div className="card-body">
        <div className="row d-block d-xl-flex align-items-center flex-xl-nowrap">
          <div className="col-12 col-xl-auto text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center flex-shrink-0">
            <div className="icon icon-shape icon-md icon-shape-blue rounded mr-4 mr-xl-3">
              <span className={'fas ' + IconStore.percent}></span>
            </div>
            <div className="d-sm-none">
              <h2 className="h5" style={textStyle}>Portfolio vs Market</h2>
              <h3 className="mb-1">{displayPortfolio}</h3>
            </div>
          </div>
          <div className="col-12 col-xl px-xl-0">
            <div className="d-none d-sm-block">
              <h2 className="h5 text-nowrap" style={textStyle}>Portfolio vs Market</h2>
              <h3 className="mb-1">{displayPortfolio}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReturnVsMarketCard;
